import { NativeCalculateResult, NativeMemberCardCoverageLine } from '@repo/types';

// The coverage row for a given (sub-group) line key, or undefined when none was returned.
export function findNativeCoverageLine(
    result: NativeCalculateResult | null,
    lineKey: string,
): NativeMemberCardCoverageLine | undefined {
    return result?.member_card?.per_line.find((line) => line.line_key === lineKey);
}

// Seed a split from the current auto coverage (nudge, never build from a blank slate): mirror auto's
// per-card split when it used two or more cards, otherwise peel the category in half.
export function seedNativeSplitSizes(
    line: NativeMemberCardCoverageLine | undefined,
    quantity: number,
): number[] {
    const units = (line?.coverage_breakdown ?? [])
        .map((segment) => segment.units)
        .filter((n) => n > 0);
    if (units.length >= 2 && units.reduce((sum, n) => sum + n, 0) <= quantity) {
        return units;
    }
    const first = Math.ceil(quantity / 2);
    return [first, quantity - first];
}
